import type { ReactElement } from 'react';
import React from 'react';
import type { ApiContentArea } from '../../../api/model';
import type { ContentRowProps } from '@/types/cms/country';
import { mapToApiContentRow } from '@/Util/globals';
import type { EditableAreaOrPageChild, PartialPageProps } from '@/types/cms/magnolia';
import ContentRowColumn from '@/components/contentModule/ContentRowColumn';

const ContentRow = (
  props: (ContentRowProps | ApiContentArea) &
    Partial<Omit<EditableAreaOrPageChild, 'pageProps'> & { pageProps?: PartialPageProps }>
): ReactElement => {
  const { leftSide, rightSide, pageProps } = props;
  const transformedApiContentRow = props ? mapToApiContentRow(props) : {};

  return (
    <div className="content-row">
      {leftSide === 'text' && rightSide === 'image' ? (
        <>
          <div className="content-row__column">
            <ContentRowColumn {...transformedApiContentRow} isRightSide pageProps={pageProps} />
          </div>
          <div className="content-row__column">
            <ContentRowColumn {...transformedApiContentRow} isLeftSide pageProps={pageProps} />
          </div>
        </>
      ) : (
        <>
          {leftSide !== 'empty' && (
            <div className="content-row__column">
              <ContentRowColumn {...transformedApiContentRow} isLeftSide pageProps={pageProps} />
            </div>
          )}
          {rightSide !== 'empty' && (
            <div className={`content-row__column${rightSide === 'image' ? ' d-xs-flex' : ''}`}>
              <ContentRowColumn {...transformedApiContentRow} isRightSide pageProps={pageProps} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ContentRow;
